import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Button } from "../components/ui/button";
import { QuotationForm } from "../components/QuotationForm";
import { WHATSAPP_URL, WHATSAPP_NUMBER } from "../lib/i18n";

export default function Contact() {
  const { t } = useLang();

  return (
    <div data-testid="contact-page">
      <section className="bg-[#0891b2] text-white py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.3em] text-red-200 mb-4 font-semibold">{t.contact.eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl" data-testid="contact-title">{t.contact.title}</h1>
          <p className="text-cyan-100 mt-3 max-w-2xl">{t.contact.subtitle}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-6 mb-12">
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="bg-green-600 hover:bg-green-700 text-white p-6 rounded-lg text-center transition-colors" data-testid="contact-whatsapp">
            <MessageCircle className="w-10 h-10 mx-auto mb-3" />
            <div className="font-display text-lg mb-1">{t.contact.whatsappCta}</div>
            <div className="text-green-100 text-sm" dir="ltr">{WHATSAPP_NUMBER}</div>
          </a>
          <a href="tel:+97142882777" className="bg-[#0891b2] hover:bg-[#ef4444] text-white p-6 rounded-lg text-center transition-colors" data-testid="contact-call">
            <Phone className="w-10 h-10 mx-auto mb-3" />
            <div className="font-display text-lg mb-1">{t.contact.callCta}</div>
            <div className="text-cyan-100 text-sm" dir="ltr">+971 4-288-2777</div>
          </a>
          <a href="mailto:admin@mariotkitchen.com" className="bg-[#ef4444] hover:bg-[#dc2626] text-white p-6 rounded-lg text-center transition-colors" data-testid="contact-email">
            <Mail className="w-10 h-10 mx-auto mb-3" />
            <div className="font-display text-lg mb-1">{t.contact.emailCta}</div>
            <div className="text-red-100 text-sm" dir="ltr">admin@mariotkitchen.com</div>
          </a>
        </div>

        <div className="max-w-3xl mx-auto px-6">
          <div className="bg-white border border-slate-200 rounded-lg p-8">
            <h2 className="font-display text-2xl text-[#0891b2] mb-2">{t.quotation.title}</h2>
            <p className="text-slate-600 text-sm mb-6">{t.quotation.subtitle}</p>
            <QuotationForm />
          </div>
        </div>
      </section>
    </div>
  );
}
